import { render, staticRenderFns } from "./PhotoStack.vue?vue&type=template&id=c141a83a&scoped=true"
import script from "./PhotoStack.vue?vue&type=script&lang=js"
export * from "./PhotoStack.vue?vue&type=script&lang=js"
import style0 from "./PhotoStack.vue?vue&type=style&index=0&id=c141a83a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c141a83a",
  null
  
)

export default component.exports